import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  COMPLIANCE_APPROVED,
  COMPLIANCE_NEW,
  COMPLIANCE_PENDING,
  COMPLIANCE_REJECTED,
  INVESTOR_TYPE_COMPANY,
  INVESTOR_TYPE_INDIVIDUAL,
  base_url,
} from "../utilities";
import axios from "axios";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import moment from "moment";
import InvestorSideNavBar from "./SideNavBarInvestor";
import InvestorNavBarMain from "./InvestorNavBar";
import { InvestorSettingsIndividual } from "./InvestorSettingsIndividual";
import {BusinessSettings} from "../BusinessFlow/BusinessSettings";
import Cookies from 'js-cookie';

const InvestorSettings = (props) => {
  const [investorDatauser, setInvestorDatauser] = useState([]);
  const navigate = useNavigate();
  

  const [defaultvalue] = useState();
  const [download, setDownload] = useState([]);
  const [getDocuments, setGetDocuments] = useState([])
  const [statusFlag, setStatusFlag] = useState(COMPLIANCE_NEW)
  const[others,setOthers]=useState([]);
  const[preOthers,setPreOthers]=useState([])
  const[deletedDoc,setDeletedDoc]=useState([])

  const currentYear = new Date().getFullYear();
  const pastYears = new Date().getFullYear() - 123;

  const startYear = pastYears;
  const endYear = currentYear;
  const years = [];

  for (let year = startYear; year <= endYear; year++) {
    years.push(year);
  }
    useEffect(()=>{
      setDeletedDoc([]);
    },[])
 useEffect(()=>{
     setOthers(preOthers);
   },[preOthers])
  useEffect(()=>{
     if (Array.isArray(getDocuments?.kyc_documents)) {
       const filteredDocs = getDocuments.kyc_documents.filter((doc) => {
         return doc.document_type.includes("Others");
       });
       setPreOthers(filteredDocs);  
     }    
     },[getDocuments]);
  
  const [updatedCustomers, setUpdatedCustomers] = useState([]);
  const [rejectedCustomers, setRejectedCustomers] = useState([]);
  const [companyFormData, setCompanyFormData] = useState({
    "investor_id": "",
      "investor_kyc_id": "",
      "user_id": "",
      "registered_address": "",
      "phone":"",
      "sector": "",
      "type": "",
      "investor_company_type": "",
      "investor_company_name": "",
      "country": "",
      "trade_license_no": "",
      "trade_license_expiry_date": "",
      "place_of_incorporation": "",
      "date_of_incorporation": "",
      "description_of_business": "",
      "beneficial_owner_with_percentage_holding": "",
      "shareholders": "",
      "products_by_the_company": "",
      "origin_of_products": "",
      "import_countries_with_percentage": "",
      "export_countries_with_percentage": "",
      "re_export_countries_with_percentage": "",
      "top_5_customers": "",
      "top_5_suppliers": "",
      "committed_principal": "",
      "no_of_full_time_employees": "",
      "is_pep": ""
  });
  useEffect(()=>(
    setCompanyFormData(masterInvestorData)
  ),[investorDatauser])
  const [indivInvFormData, setIndivInvFormData] = useState(
    {
      "investor_id": "",
      "investor_kyc_id": "",
      "user_id": "",
      "gender": "",
      "phone": "",
      "registered_address": "",
      "nationality": "",
      "country": "",
      "home_country_contact": "",
      "country_of_birth": "",
      "date_of_birth": "",
      "passport_number": "",
      "passport_expiry_date": "",
      "description_of_income": "",
      "sourse_of_fund": "",
      "nominee_details": "",
      "name_of_employer": "",
      "country_of_employer": "",
      "national_id": "",
      "other_passport_details": "",
      "committed_principal": "",
      "created_by": Cookies.get("Inv_login_user"),
      "is_pep": ""
    }
  );  
  const [indivInvFormData2, setIndivInvFormData2] = useState(
    {
      "investor_id": "",
      "is_pep": ""
    }
  );

  const handleChangeDownloadForOthers = (event, file,doc) => {

    if(file instanceof File)
    {
      const fileURL = URL.createObjectURL(file);
       window.open(fileURL, '_blank');
    }
    else
    {
      if (file.document_url && typeof file.document_url === 'string') {
               window.open(file.document_url, '_blank');
            }
    }
  }

  const handleDeleteClickOthers = (item) => {
    let updatedOthers;
  if (item instanceof File) {
    updatedOthers = others.filter((doc) => doc.name !== item.name);
  } else {
    updatedOthers = others.filter((doc) => doc.document_type !== item.document_type);
  }
    setOthers(updatedOthers);
    if(preOthers.length>0 && !(item instanceof File))
    handleDeleteDocForOthers(item);
  };

  const handleDeleteDocForOthers=(item)=>{
    setDeletedDoc(prevItems => [...prevItems, item.document_id]);
   }
  const [updatedSuppliers, setUpdatedSuppliers] = useState([]);
  const [rejectedSuppliers, setRejectedSuppliers] = useState([]);
  const [updatedBanks, setUpdatedBanks] = useState([]);
  const [rejectedBanks, setRejectedBanks] = useState([]);

  const [rejectedFlag, setRejectedFlag] = useState(true);
  const [rejectedInvDetails, setRejectedInvDetails] = useState()




  useEffect(() => {
    if (!Cookies.get("User_Accesstoken")) {
      navigate("/");
    }
    axios
    .post(base_url + "investor-master/get_investor_master_user", {
      user_id: Cookies.get("investor_user_id"),
    })
    .then((res) => {
      let data = res.data.data
      setInvestorDatauser(data);


      if(res.data.data.kyc?.length===0 || res.data.data.kyc[0]?.status!=COMPLIANCE_APPROVED){
        Cookies.set("kyc_status", 0, { expires: 7 })
      }else{
        Cookies.set("kyc_status", 2, { expires: 7 })
      }

      setCompanyFormData(prev => ({...prev,
        phone : data?.phone,
        investor_company_name:data?.investor_company_name,
        type : data?.type,
        user_id:data.user_id,
        investor_id:data.investor_id,
        country : data?.country=="undefined" ? '':data?.country,

      }))
      setIndivInvFormData(prev => ({...prev,
        phone : data?.phone,
        type : data?.type,
        user_id:data.user_id,
        investor_id:data.investor_id,
        country : data?.country=="undefined" ? '':data?.country,
        nationality:data?.nationality=="undefined" ? '':data?.nationality,

      }))
      if(data.kyc?.length ===0 || data.kyc[0]?.status===COMPLIANCE_REJECTED ){

        setRejectedFlag(false)
      }
      if(statusFlag===COMPLIANCE_NEW){
          
        setRejectedFlag( false)
      }
    })
    .catch((err) => {
      console.error("Error fetching investor master user:", err.response || err.message);
    });

  axios
    .post(base_url + "documents-type/get_document_types")
    .then((res) => {
      let doctypes = res.data.data;
      let x = [];
      if(Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL){
        
        doctypes.INVESTOR_INDIVIDUAL_KYC_FORM_DOCS.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
      }
      if(Cookies.get("investor_type")===INVESTOR_TYPE_COMPANY){
        
        doctypes.INVESTOR_COMPANY_KYC_FORM_DOCS.forEach((element) => {
          x.push({ doc_type: element, is_upload: false, file_name: "" });
        });
      }
      setDownload(x);
    })
    .catch((err) => {
      console.log(err);
    });
    
  }, [Cookies.get("user_id"), statusFlag]);
    
 
  const[mergedDownloads,setMergedDownloads]=useState([])
  const[savedDocuments,setSavedDocuments]=useState([]);
  useEffect(() => {
    if (statusFlag === COMPLIANCE_NEW) {
      const currentDocuments = getDocuments?.kyc_documents || [];
      setSavedDocuments((prevDocuments) => Array.isArray(prevDocuments)
        ? [...prevDocuments, ...currentDocuments]
        : currentDocuments);
        const updatedDownloads =download?.map((item) => {
          const matchedDocument = getDocuments?.kyc_documents?.find((doc) => {
          const trimmedDocType = doc.document_type?.replace(/\s+/g, '').trim();
          const trimmedItemType = item.doc_type?.replace(/\s+/g, '').trim();
          return trimmedItemType.includes(trimmedDocType);
        });
        
        return matchedDocument
          ? { ...item, ...matchedDocument, is_upload: true } 
          : item;
      });
      setMergedDownloads(updatedDownloads);
  
    } 
    else{
      setMergedDownloads(download);
    }
},[statusFlag,getDocuments]);
useEffect(()=>{
  if (preOthers.length !== 0) {
    setMergedDownloads(prevDownloads =>
      Array.isArray(prevDownloads)
        ? prevDownloads.map(item =>
        item.doc_type === 'Others' ? { ...item, is_upload: true } : item
      ): prevDownloads
    );
  }
},[preOthers])


  const[isDataNull,setIsDataNull]=useState(false);
  const [index, setIndex] = useState(0)
  const [shareHolderData, setShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);
  const [rejectedShareHolderData, setRejectedShareHolderData] = useState([
    { index: index, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" },
  ]);
  
 
  const handleInputChange = (index, columnName, value) => {
   if((investorDatauser?.kyc?.length===0)||
   (investorDatauser?.kyc?.length>0 && statusFlag===COMPLIANCE_NEW)){ const newData = [...shareHolderData];
    newData[index][columnName] = value;
    setShareHolderData(newData);}
    
   if(statusFlag===COMPLIANCE_REJECTED){ 
    
    const newData = [...rejectedShareHolderData];
    newData[index][columnName] = value;
    setRejectedShareHolderData(newData);}



  };

  let plusDisabled =shareHolderData.some((obj) => Object.values(obj).some((value) => value === ''))
  const handleAddRow = () => {
     
    if(!plusDisabled ){
    const newRow = { index: index + 1, name_of_shareholder: "", designation_of_shareholder: "", nationality_of_shareholder: "", dob_of_shareholder: "", residential_country_of_shareholder: "" };
    if(investorDatauser?.kyc?.length===0 || statusFlag=== COMPLIANCE_NEW){setShareHolderData([...shareHolderData, newRow]);}
    if(statusFlag===COMPLIANCE_REJECTED){setRejectedShareHolderData([...rejectedShareHolderData, newRow]);}
    
    setIndex(index + 1)}
  };
  const handleRemoveRow = (index) => {
    if(index!==0){if(investorDatauser?.kyc?.length===0 || statusFlag=== COMPLIANCE_NEW){setShareHolderData(shareHolderData.filter((_, i) => i !== index));}
    if(statusFlag===COMPLIANCE_REJECTED){setShareHolderData(shareHolderData.filter((_, i) => i !== index));}}
  };





 

  const handleFieldChange = (fieldName, value) => {

    if(Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL){
      if(fieldName ==="gender" && value ==="Select"){
    setIndivInvFormData((prev => (
      {...prev, 
        [fieldName]:""})))
      }else{
        setIndivInvFormData((prev => (
          {...prev, 
            [fieldName]:value})))
            setCompanyFormData((prevData) => ({
              ...prevData,
              [fieldName]: value,
            }))
      }
   
      
  if(statusFlag===COMPLIANCE_REJECTED)
    {
      setCompanyFormData((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
      setRejectedInvDetails((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }));
    }

   if(investorDatauser?.kyc[0]?.status===COMPLIANCE_REJECTED){ 
      setSaveKYCBtn(false)
      setRejectedInvDetails((prevData) => ({
        ...prevData,
        [fieldName]: value,
      }))}
    }

    if(Cookies.get("investor_type")===INVESTOR_TYPE_COMPANY){

    if(investorDatauser?.kyc?.length===0|| statusFlag===COMPLIANCE_NEW){ 
      setCompanyFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }))
  }
  if(statusFlag===COMPLIANCE_REJECTED)
  {
    setCompanyFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
    setRejectedInvDetails((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  }
   else if(investorDatauser?.kyc[0]?.status===COMPLIANCE_REJECTED){ 
    setSaveKYCBtn(false)
    setRejectedInvDetails((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));}}

  };

  var currentDate = new Date(); 
  currentDate.setDate(currentDate.getDate() + 1); 
  
  const tomorrow = currentDate.toISOString().split('T')[0];
  
   
  let rowCount = window.screen.availWidth > 1860 ? 8 : 4;

  const handleCustomerChange = (index, value ) => {
    if((investorDatauser?.kyc?.length===0) || 
    (investorDatauser?.kyc?.length>0 && statusFlag===COMPLIANCE_NEW)){  
      const customers = [...updatedCustomers];
      customers[index] = value;
      setUpdatedCustomers(customers)}
      
      if(statusFlag=== COMPLIANCE_REJECTED){ 
      let customers = [...rejectedCustomers];
      customers[index] = value;
       setRejectedCustomers(customers)
       setUpdatedCustomers(customers)
    }
  
    };

  const handleSupplierChange = (index, value) => {
 
    if((investorDatauser?.kyc?.length===0) || 
    (investorDatauser?.kyc?.length>0 && statusFlag===COMPLIANCE_NEW)){
      const suppliers = [...updatedSuppliers];
    suppliers[index] = value;
    setUpdatedSuppliers(suppliers)
  }
    if(statusFlag===COMPLIANCE_REJECTED){
      const suppliers = [...rejectedSuppliers];
      suppliers[index] = value;
      setRejectedSuppliers(suppliers)
      setUpdatedSuppliers(suppliers)
    }
    
  };
 
  const handleBankChange = (index, value) => {
   if(investorDatauser?.kyc?.length===0){ const banks = [...updatedBanks];
    banks[index] = value;
    setUpdatedBanks(banks)}

   if(statusFlag===COMPLIANCE_REJECTED){ const banks = [...rejectedBanks];
    banks[index] = value;
    setRejectedBanks(banks)
    setUpdatedBanks(banks)}
  };


  const handleChange = (event, item, index) => {
      const maxFileSize = 5242880; 
      const files = Array.from(event.target.files);
      let sample_download = [];
      if (isDataNull) sample_download = [...download];
      else sample_download = [...mergedDownloads];  
      sample_download.forEach((doc) => {
        if (doc.doc_type === item.doc_type) {
          if (item.doc_type === "Others") {  
            if (others.length < 10) {
              const validFiles = files.filter((file) => file.size < maxFileSize);
              const invalidFiles = files.filter((file) => file.size >= maxFileSize);
              if (invalidFiles.length > 0) {
                toast.error("Some files exceed 5MB and were not uploaded.", {
                  toastId: 7,
                });
              }
              doc.is_upload = true;
              doc.uploaded_files = [...(doc.uploaded_files || []), ...validFiles.map((file) => ({
                file_name: file.name,
                document_url: file,
              }))];
              validFiles.forEach((file) => {
                setOthers((prevItems) => [...prevItems, file]);
              });
            } else {
              toast.warn("Max limit of 50 files reached!");
            }
          } else {
            if (files[0]?.size < maxFileSize) {
              doc.is_upload = true;
              doc.document_type = item.doc_type;
              doc.document_url = files[0];
              doc.file_name = files[0].name;
            } else {
              toast.error("File size should be less than 5MB", {
                toastId: 7,
              });
            }
          }
        }
      });
    
      setDownload(sample_download);
    };

  const handleChangeDownload = (event, item) => {
    if (item.document_url && typeof item.document_url === 'string') {
      window.open(item.document_url, '_blank');
    } if (item.document_url instanceof File) {
      const fileURL = URL.createObjectURL(item.document_url);
      window.open(fileURL, '_blank');
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [masterInvestorData, setMasterInvestorData] = useState([])
  useEffect(() => {
    if (masterInvestorData?.top_5_customers?.length > 0) {
      setUpdatedCustomers(masterInvestorData.top_5_customers);
    }
    if (masterInvestorData?.top_5_suppliers?.length > 0) {
      setUpdatedSuppliers(masterInvestorData.top_5_suppliers);
    }
    if (masterInvestorData?.banks_list?.length > 0) {
      setUpdatedBanks(masterInvestorData.banks_list);
    }
    if (masterInvestorData?.shareholders?.length > 0) {
      setShareHolderData(masterInvestorData.shareholders);
    }
  }, [masterInvestorData]);
  useEffect(() => {
    if (investorDatauser?.length > 0) {
      if (investorDatauser?.kyc[0]?.status === COMPLIANCE_APPROVED) {
        Cookies.set("kyc_status", COMPLIANCE_APPROVED, { expires: 7 })
      }
    }
    if (investorDatauser?.user_id) {
      axios
        .post(
          base_url + "investor-master/get_investor_kyc_user",
          { user_id: investorDatauser?.user_id }
        )
      .then((res) => {
        if(res.data?.data?.length===0)
          {
            setIsDataNull(true)
          }
        let data0 = res.data.data[0] ||[]
        if(data0?.kyc_expiry_date!=null && data0?.kyc_expiry_date <= new Date().getTime()|| data0?.status ===undefined){
          setStatusFlag(COMPLIANCE_NEW)
        } else {
          setStatusFlag(data0?.status)

        }

        if(data0===undefined){setMasterInvestorData([])}else{setMasterInvestorData(data0)}

        setGetDocuments(res?.data.data[1])
        setSavedDocuments(res?.data.data[1])
        setRejectedCustomers(data0?.top_5_customers)
        setRejectedSuppliers(data0?.top_5_suppliers)
        setRejectedBanks(data0?.banks_list)
        setRejectedShareHolderData(data0?.shareholders)
       if(data0 && Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL){ 
        setRejectedInvDetails({
          "investor_id":data0.investor_id,
          "type": data0.type,
          "investor_kyc_id":data0.investor_kyc_id,
          "user_id":data0.user_id,
          "gender":data0.gender,
          "phone":data0.phone,
          "registered_address":data0.registered_address,
          "nationality":data0.nationality,
          "country":data0.country,
          "home_country_contact":data0.home_country_contact,
          "country_of_birth":data0.country_of_birth,
          "date_of_birth":data0.date_of_birth,
          "passport_number":data0.passport_number,
          "passport_expiry_date":data0.passport_expiry_date,
          "description_of_income":data0.description_of_income,
          "sourse_of_fund":data0.sourse_of_fund,
          "nominee_details":data0.nominee_details,
          "name_of_employer":data0.name_of_employer,
          "country_of_employer":data0.country_of_employer,
          "national_id":data0.national_id,
          "other_passport_details":data0.other_passport_details,
          "committed_principal":data0.committed_principal,
          "is_pep":data0.is_pep,
        })}else{
          setRejectedInvDetails({
            "investor_id": data0?.investor_id,
      "investor_kyc_id": data0?.investor_kyc_id,
      "user_id": data0?.user_id,
      "phone":data0?.phone,
      "registered_address": data0?.registered_address,
      "sector": data0?.sector,
      "type": data0?.type,
      "investor_company_type": data0?.investor_company_type,
      "investor_company_name": data0?.investor_company_name,
      "country": data0?.country,
      "trade_license_no": data0?.trade_license_no,
      "trade_license_expiry_date": data0?.trade_license_expiry_date,
      "place_of_incorporation": data0?.place_of_incorporation,
      "date_of_incorporation": data0?.date_of_incorporation,
      "description_of_business": data0?.description_of_business,
      "beneficial_owner_with_percentage_holding": data0?.beneficial_owner_with_percentage_holding,
      "shareholders": data0?.shareholders,
      "products_by_the_company": data0?.products_by_the_company,
      "origin_of_products": data0?.origin_of_products,
      "import_countries_with_percentage": data0?.import_countries_with_percentage,
      "export_countries_with_percentage": data0?.export_countries_with_percentage,
      "re_export_countries_with_percentage": data0?.re_export_countries_with_percentage,
      "top_5_customers": data0?.top_5_customers,
      "top_5_suppliers": data0?.top_5_suppliers,
      "committed_principal": data0?.committed_principal,
      "no_of_full_time_employees":data0?.no_of_full_time_employees,
      "is_pep" : data0?.is_pep
          })
        }
      })
    }
  }, [investorDatauser?.user_id, investorDatauser])

 const [saveKYCBtn, setSaveKYCBtn] = useState(false)
const handleSaveDraft=async()=>{
  setSaveKYCBtn(true);
  const fInvData = new FormData();
    const data = {
     "investor_id": investorDatauser.investor_id,
      "user_id": investorDatauser.user_id,
      "gender": "",
      "phone": investorDatauser.phone,
      "registered_address": "",
      "nationality": investorDatauser.nationality,
      "country": investorDatauser.country,
      "home_country_contact": "",
      "country_of_birth": "",
      "date_of_birth": investorDatauser.country_of_birth,
      "passport_number": "",
      "passport_expiry_date": "",
      "description_of_income": "",
      "sourse_of_fund": "",
      "nominee_details": "",
      "name_of_employer": "",
      "country_of_employer": "",
      "national_id": "",
      "other_passport_details": "",
      "committed_principal": "",
      "created_by": investorDatauser.created_by,
      "is_pep": ""
    };
    
     
    for (const key in data) {
      if(key==="date_of_birth" || key ==="passport_expiry_date"){
        if(data.hasOwnProperty(key) && indivInvFormData[key]!=undefined ){
          const timstampDate = new Date(indivInvFormData[key]).getTime()
          fInvData.append(key, timstampDate);
        }
      } else if (data.hasOwnProperty(key)) {
        if (indivInvFormData[key] !== undefined && indivInvFormData[key] !== null) {
          fInvData.append(key, indivInvFormData[key]);
          }
          else if (data[key] !== undefined && data[key]!=null) {
            fInvData.append(key, data[key]);
          }
             else{
              fInvData.append(key,"");
      }
    }
    }
    
    let documents_lst = [];

    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          is_upload: !!eachDoc.document_url
        });
      }
    });
    documents_lst.forEach(elem => {
      if (elem.document_url.name) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fInvData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
      }
    })

    if(others.length!==0)
      {
        others.filter((doc) => doc && doc.name).forEach((doc) => {
          const fileName = doc?.name;
          if (fileName) {
            fInvData.append('file_name', fileName);
            const lastDotIndex = fileName.lastIndexOf('.');
            const fileExtension = fileName.substring(lastDotIndex + 1);
            fInvData.append('file', doc, "Others" + "." + fileExtension);
          }
        });
      }
      if (!isDataNull) {
        fInvData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
      }
    fInvData.append('save_as_draft','1');
    fInvData.append('status',statusFlag);
    fInvData.append("deleted_doc",deletedDoc);

    try{
  const response = await axios.post(base_url + "investor-master/save_investor_master", fInvData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
   if(response.data.message === 'Investor KYC draft saved successfully') {
          toast.success("Draft saved successfully", {
            toastId: 40,
          });
   }
      } catch (error) {
        toast.error("Failed to save draft", {
          toastId: 41,
        }); 
      }
      finally{
        setSaveKYCBtn(false);
        setTimeout(()=>{
          window.location.reload();
          },200)
      }
}


const getExtensionFromURL = (url) => {
  try {
    const pathname = new URL(url).pathname; 
    const parts = pathname.split('.');
    return parts.length > 1 ? parts.pop() : null; 
  } catch (error) {
    return null;
  }
};
const[documents,setDocuments]=useState([]);
const handleSaveDraftCompany=async()=>{
  setSaveKYCBtn(true);
  const fData = new FormData();
  const data = {
    "investor_id": investorDatauser.investor_id,
     "user_id": investorDatauser.user_id,
     "phone": investorDatauser.phone,
     "beneficial_owner_with_percentage_holding": "",

"committed_principal":"",

"date_of_incorporation":"", 

"description_of_business": "",

"export_countries_with_percentage":"", 

"import_countries_with_percentage": "",

"investor_company_type":investorDatauser.type, 
"is_pep": "",

"no_of_full_time_employees":"", 

"origin_of_products":"", 

"place_of_incorporation":"", 

"products_by_the_company":"", 

"re_export_countries_with_percentage":"", 

"registered_address":"", 

"sector":"", 

"trade_license_expiry_date":"", 

"trade_license_no":"", 

"created_by": investorDatauser.created_by,
"country":investorDatauser.country,
   };
   for (const key in data) {
    if(key==="date_of_incorporation" || key ==="trade_license_expiry_date"){
      if(data.hasOwnProperty(key) && companyFormData[key]!=undefined ){
        const timstampDate = new Date(companyFormData[key]).getTime()
        fData.append(key, timstampDate);
      }
    } 
    else if (data.hasOwnProperty(key)) {
      if (companyFormData[key] !== undefined && companyFormData[key] !== null) {
         fData.append(key, companyFormData[key]);
        }
        else if (data[key] !== undefined && data[key]!=null) {
         fData.append(key, data[key]);
        }
           else{
            fData.append(key,"");
    }
  }
  }
  for (let i = 0; i < updatedCustomers.length; i++) {
    if(updatedCustomers[i]) {
      fData.append('top_5_customers', updatedCustomers[i]);
    }
  }
  
  for (let i = 0; i < updatedSuppliers.length; i++) {
    if(updatedSuppliers[i]) {
      fData.append('top_5_suppliers', updatedSuppliers[i]);
    }
  }
  
  for (let i = 0; i < updatedBanks.length; i++) {
    if(updatedBanks[i]) {
      fData.append('banks_list', updatedBanks[i]);
    }
  }
  let documents_lst = [];
  download.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
        is_upload: !!eachDoc.document_url
      });
    }
  });

  documents_lst.forEach(elem => {
    if (elem.document_url.name) {
      const fileName = elem.document_url.name;
      const lastDotIndex = fileName.lastIndexOf('.');
      const fileExtension = fileName.substring(lastDotIndex + 1);
      fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
      
    }
  })

  if(others.length!==0)
    {
      others.filter((doc) => doc && doc.name).forEach((doc) => {
        const fileName = doc?.name;
        if (fileName) {
          fData.append('file_name', fileName);
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fData.append('file', doc, "Others" + "." + fileExtension);
        }
      });
    }
    if (!isDataNull) {
      fData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
    }

  if (Array.isArray(getDocuments?.kyc_documents) && getDocuments.kyc_documents.length > 0) {
    getDocuments.kyc_documents.forEach((doc, index) => {
      if (doc?.document_url) {
       documents.push(doc.document_url);
      }
    });
  }
  fData.append('shareholders', JSON.stringify(shareHolderData));
  fData.append("deleted_doc",deletedDoc);
  fData.append('save_as_draft', '1');
  fData.append('status', statusFlag);

    try{
    const response = await axios.post(
      base_url + "investor-master/save_investor_master", 
      fData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    if(response.data.message === 'Investor KYC draft saved successfully') {
            toast.success("Draft saved successfully", {
              toastId: 40,
            });
    }
  }
  catch (error) {
        toast.error("Failed to save draft", {
          toastId: 41,
        }); 
  }
  finally{
    setSaveKYCBtn(false);
    setTimeout(()=>{
      window.location.reload();
      },200)
  }
}
const handleSavechanges = async (data) => {
  setSaveKYCBtn(true)
  if(Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL){
    const fInvData = new FormData();
    const data = {
      "user_id": investorDatauser.user_id,
      "gender": "",
      "phone": investorDatauser.phone,
      "registered_address": "",
      "nationality": investorDatauser.nationality,
      "country": investorDatauser.country,
      "home_country_contact": "",
      "country_of_birth": "",
      "date_of_birth": investorDatauser.country_of_birth,
      "passport_number": "",
      "passport_expiry_date": "",
      "description_of_income": "",
      "sourse_of_fund": "",
      "nominee_details": "",
      "name_of_employer": "",
      "country_of_employer": "",
      "national_id": "",
      "other_passport_details": "",
      "committed_principal": "",
      "created_by":  investorDatauser.created_by,
      "is_pep": ""
    };
    
     
    for (const key in data) {
      if(key==="date_of_birth" || key ==="passport_expiry_date"){
        if(data.hasOwnProperty(key) && indivInvFormData[key] ){
          const timstampDate = new Date(indivInvFormData[key]).getTime()
          fInvData.append(key, timstampDate);
        }
      } else if (data.hasOwnProperty(key)) {
        if (indivInvFormData[key] !== undefined) {
          fInvData.append(key, indivInvFormData[key]);  
        }
        else if (data[key] !== undefined) {
          fInvData.append(key, data[key]);  
        }  
      }
    } 
    let documents_lst = [];

    if(isDataNull)
      download.map((eachDoc) => {
        if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
          documents_lst.push({
            document_type: eachDoc.document_type,
            document_url: eachDoc.document_url,
            is_upload: !!eachDoc.document_url
          });
        }
      });

      else
      mergedDownloads.map((eachDoc) => {
        if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
          documents_lst.push({
            document_type: eachDoc.document_type,
            document_url: eachDoc.document_url,
            is_upload: !!eachDoc.document_url
          });
        }
      });
    
    const requiredDocuments = [
      "ID Proof - Address Proof",
      "ID Proof - National ID",
      "ID Proof - Passport/ Government Issued ID",
      "3 Months Bank Account Statement",
      "ID Proof - Nominee",
      "ID Proof - Guardian",
      "Photograph"
    ];


    const allRequiredUploaded = requiredDocuments.every((type) => {
      const normalizedType = type.replace(/[^a-zA-Z0-9]/g, '');  
      const isUploaded = documents_lst.some((doc) => {
        const normalizedDocType = doc.document_type.replace(/[^a-zA-Z0-9]/g, '');  
        const match = normalizedType.includes(normalizedDocType) && doc.is_upload;
        return match;
      });
      return isUploaded;
    });        
    
    // Check if "Months Bank Account Statement" exists and is uploaded
    const bankStatementUploaded = documents_lst.some(
      (doc) => doc.document_type.includes("Bank Account Statement") && doc.is_upload
    );
    // Set mandatoryDocuments to true if both conditions are met
    const mandatoryDocuments = allRequiredUploaded && bankStatementUploaded;
    if (
  (indivInvFormData?.committed_principal === '' || indivInvFormData?.committed_principal === null) ||
  (indivInvFormData?.country === '' || indivInvFormData?.country === null) ||
  (indivInvFormData?.country_of_birth === '' || indivInvFormData?.country_of_birth === null) ||
  (indivInvFormData?.country_of_employer === '' || indivInvFormData?.country_of_employer === null) ||
  (indivInvFormData?.date_of_birth === '' || indivInvFormData?.date_of_birth === null) ||
  (indivInvFormData?.description_of_income === '' || indivInvFormData?.description_of_income === null) ||
  (indivInvFormData?.nationality === '' || indivInvFormData?.nationality === null) ||
  (indivInvFormData?.gender === '' || indivInvFormData?.gender === null) ||
  (indivInvFormData?.is_pep === '' || indivInvFormData?.is_pep === null) ||
  (indivInvFormData?.name_of_employer === '' || indivInvFormData?.name_of_employer === null) ||
  (indivInvFormData?.national_id === '' || indivInvFormData?.national_id === null) ||
  (indivInvFormData?.nominee_details === '' || indivInvFormData?.nominee_details === null) ||
  (indivInvFormData?.passport_expiry_date === '' || indivInvFormData?.passport_expiry_date === null) ||
  (indivInvFormData?.passport_number === '' || indivInvFormData?.passport_number === null) ||
  (indivInvFormData?.registered_address === '' || indivInvFormData?.registered_address === null) ||
  (indivInvFormData?.sourse_of_fund === '' || indivInvFormData?.sourse_of_fund === null) ||
  (indivInvFormData?.phone === '' || indivInvFormData?.phone === null)
      
      
      
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
      setSaveKYCBtn(false)
    }else if(!mandatoryDocuments){
      toast.error("Please upload mandatory documents", {
        toastId: 333,
      });
      setSaveKYCBtn(false)
    }
    else {
      setSaveKYCBtn(true)
      documents_lst.forEach(elem => {
        if (elem.document_url.name) {
          const fileName = elem.document_url.name;
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fInvData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
          if (elem.document_type === "Others") {
            fInvData.append('file_name', fileName);
          }
        }
      })
      fInvData.append("deleted_doc",deletedDoc);
      fInvData.append('save_as_draft', '0');
      fInvData.append('investor_id',investorDatauser.investor_id)
      if (!isDataNull) {
        fInvData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
      }
      if(others.length!==0)
        {
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              fInvData.append('file_name', fileName);
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);
              
              fInvData.append('file', doc, "Others" + "." + fileExtension);
            }
          });
          
        }
      const response = await axios.post(base_url + "investor-master/update_investor_master", fInvData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
     if(response.data.message ==='Updated Investor KYC'){
        toast.success("Submitted Successfully", {
          toastId: 42,
  });
  setTimeout(() => {
    window.location.reload();
  }, 800);
}
}


  }
  else if(Cookies.get("investor_type")===INVESTOR_TYPE_COMPANY){
setSaveKYCBtn(true)
const fData = new FormData();
let documents_lst = [];

if(isDataNull)
  download.map((eachDoc) => {
    if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
      documents_lst.push({
        document_type: eachDoc.document_type,
        document_url: eachDoc.document_url,
        is_upload: !!eachDoc.document_url
      });
    }
  });

else
mergedDownloads.map((eachDoc) => {
  if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
    documents_lst.push({
      document_type: eachDoc.document_type,
      document_url: eachDoc.document_url,
      is_upload: !!eachDoc.document_url
    });
  }
});

    const requiredDocuments = [
      "Valid Trade License",
      "MOA Document",
      "Board Resolution Document",
      "ID Proof - Passport/ Government Issued ID",
      "ID Proof - National ID",
      "VAT Certificate",
      "ID Proof - Address Proof",
    ];
    // Check if all required documents are uploaded
    const allRequiredUploaded = requiredDocuments.every((type) => {
      const normalizedType = type.replace(/[^a-zA-Z0-9]/g, '');  
      const isUploaded = documents_lst.some((doc) => {
        const normalizedDocType = doc.document_type.replace(/[^a-zA-Z0-9]/g, '');  
        const match = normalizedType.includes(normalizedDocType) && doc.is_upload;
        return match;
      });
      return isUploaded;
    });  

    // Check if "Months Bank Account Statement" exists and is uploaded
    const bankStatementUploaded = documents_lst.some(
      (doc) => doc.document_type.includes("Bank Account Statement") && doc.is_upload
    );
    
    // Set mandatoryDocuments to true if both conditions are met
    const mandatoryDocuments = allRequiredUploaded && bankStatementUploaded;
    

    for (let i = 0; i < updatedCustomers.length; i++) {
      if(updatedCustomers[i]!==undefined){
        fData.append('top_5_customers', updatedCustomers[i])};
    }
    for (let i = 0; i < updatedSuppliers.length; i++) {
      if(updatedSuppliers[i]!==undefined){fData.append('top_5_suppliers', updatedSuppliers[i])};
    }
    // for (let i = 0; i < updatedBanks.length; i++) {
    //   if(updatedBanks[i]!==undefined){fData.append('banks_list', updatedBanks[i])}
    // }

let companydata = {
    "registered_address": "",
    "sector": "",
    "trade_license_no": "",
    "trade_license_expiry_date": "",
    "place_of_incorporation": "",
    "date_of_incorporation": "",
    "description_of_business": "",
    "beneficial_owner_with_percentage_holding": "",
    // "shareholders": "",
    "products_by_the_company": "",
    "origin_of_products": "",
    "import_countries_with_percentage": "",
    "export_countries_with_percentage": "",
    "re_export_countries_with_percentage": "",
    "committed_principal": "",
    "no_of_full_time_employees": "",
    "is_pep": ""
}


for (const key in companydata) {
  if(key==="trade_license_expiry_date" || key==="date_of_incorporation"){
    if(companydata.hasOwnProperty(key) && companyFormData[key]!=undefined ){
      const timstampDate = new Date(companyFormData[key]).getTime()
      fData.append(key, timstampDate);
    }
  }else if (companydata.hasOwnProperty(key)) {
    if (companydata[key] !== undefined) {
      fData.append(key, companyFormData[key]);
    }
    else if (companydata[key] !== undefined) {
      fData.append(key, companydata[key]);  
    }  
  }
}
    
    fData.append('shareholders', JSON.stringify(shareHolderData));
     
    
    if (
      (companyFormData?.sector === '' || companyFormData?.sector === null) ||
      (companyFormData?.country === '' || companyFormData?.country === null) ||
      (companyFormData?.registered_address === '' || companyFormData?.registered_address === null) ||
      (companyFormData?.investor_company_type === '' || companyFormData?.investor_company_type === null) ||
      (companyFormData?.phone === '' || companyFormData?.phone === null) ||
      (companyFormData?.committed_principal === '' || companyFormData?.committed_principal === null) ||
      (companyFormData?.place_of_incorporation === '' || companyFormData?.place_of_incorporation === null) ||
      (companyFormData?.date_of_incorporation === '' || companyFormData?.date_of_incorporation === null) ||
      (companyFormData?.trade_license_no === '' || companyFormData?.trade_license_no === null) ||
      (companyFormData?.trade_license_expiry_date === '' || companyFormData?.trade_license_expiry_date === null) ||
      (companyFormData?.description_of_business === '' || companyFormData?.description_of_business === null) ||
      (companyFormData?.beneficial_owner_with_percentage_holding === '' || companyFormData?.beneficial_owner_with_percentage_holding === null) ||
      (companyFormData?.products_by_the_company === '' || companyFormData?.products_by_the_company === null) ||
      (companyFormData?.origin_of_products === '' || companyFormData?.origin_of_products === null) ||
      (companyFormData?.import_countries_with_percentage === '' || companyFormData?.import_countries_with_percentage === null) ||
      (companyFormData?.export_countries_with_percentage === '' || companyFormData?.export_countries_with_percentage === null) ||
      (companyFormData?.re_export_countries_with_percentage === '' || companyFormData?.re_export_countries_with_percentage === null) ||
      (companyFormData?.no_of_full_time_employees === '' || companyFormData?.no_of_full_time_employees === null) ||
      (companyFormData?.top_5_customers === '' || companyFormData?.top_5_customers === null) ||
      (companyFormData?.top_5_suppliers === '' || companyFormData?.top_5_suppliers === null) ||
      (companyFormData?.is_pep === '' || companyFormData?.is_pep === null)
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 3,
      });
      setSaveKYCBtn(false)
    } else if(!mandatoryDocuments){
      toast.error("Please upload madatory documents", {
        toastId: 526,
      });
    }
      else if(plusDisabled){
      toast.error("Please fill atleast one shareholder details", {
        toastId: 3,
      });
      setSaveKYCBtn(false)
    }
    else {
      setSaveKYCBtn(true)

      const fetchFile = async (url) => {
        const response = await fetch(url);
        const blob = await response.blob();
        return blob;
      };
      documents_lst.forEach (async(elem) => {
        if (elem.document_url && elem.document_url.name) {
          const fileName = elem.document_url.name;
          const lastDotIndex = fileName.lastIndexOf('.');
          const fileExtension = fileName.substring(lastDotIndex + 1);
          fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
        } 
        else {
          const url = elem.document_url;
          const fileExtension = url.split('.').pop();  
      
          try {
            const fileBlob = await fetchFile(url); 
            fData.append('file', fileBlob, elem.document_type + "." + fileExtension);  
          } catch (error) {
            console.error("Error fetching file from URL:", error);
          }
        }
      });
      if(others.length!==0)
        {
          others.filter((doc) => doc && doc.name).forEach((doc) => {
            const fileName = doc?.name;
            if (fileName) {
              fData.append('file_name', fileName);
              const lastDotIndex = fileName.lastIndexOf('.');
              const fileExtension = fileName.substring(lastDotIndex + 1);
              fData.append('file', doc, "Others" + "." + fileExtension);
            }
          });
        }
        if (!isDataNull) {
          fData.append('investor_kyc_id', investorDatauser.kyc[0]?.investor_kyc_id);
        }
        fData.append("investor_id",investorDatauser.investor_id)
        fData.append("user_id",investorDatauser.user_id)
        fData.append("phone",investorDatauser.phone)
        fData.append("type",investorDatauser.type)
        fData.append("country",investorDatauser.country)
        fData.append("investor_company_name",investorDatauser.investor_company_name)


        fData.append("deleted_doc",deletedDoc);
        fData.append('save_as_draft', '0');
      const response =await axios.post(base_url + "investor-master/update_investor_master", fData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
     
      if(response.data.message ==='Updated Investor KYC'){
        toast.success("Submitted Successfully", {
          toastId: 42,
  });
  setTimeout(() => {
    window.location.reload();
  }, 800);
}
}
}
  }
  const handleDeleteClick = (item) => {
    let sample_download = [...download];
    sample_download.forEach((doc) => {
      if (doc.doc_type == item.doc_type) {
        item.is_upload = false;
        doc.is_upload = false;
        doc.document_type = "";
        doc.document_url = "";
        doc.file_name = "";
      }
    });
    setDownload(sample_download);
    handleDeleteDoc(item);
  };

  const handleDeleteDoc=(item)=>{
    setDeletedDoc(prevItems => [...prevItems, item.document_id]);
  }
  

  const handleUpdateKyc =async ()=>{
    setSaveKYCBtn(true)
    const fData = new FormData();

    let documents_lst = [];

    download.map((eachDoc) => {
      if (eachDoc.document_type != undefined || eachDoc.document_type != null) {
        documents_lst.push({
          document_type: eachDoc.document_type,
          document_url: eachDoc.document_url,
          // is_upload: !!eachDoc.document_url
        });
      }
    });
    // const requiredDocuments = [
    //   "ID Proof - National ID",
    //   "6 Months Bank Account Statement"
    // ];


    // const mandatoryDocuments = requiredDocuments.every((type) =>
    //   documents_lst.some((doc) => doc.document_type === type && doc.is_upload)
    // );
    
   if(Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL){ fData.append('investor_id', rejectedInvDetails?.investor_id);
    fData.append('investor_kyc_id', rejectedInvDetails?.investor_kyc_id);
    fData.append('user_id', rejectedInvDetails?.user_id);
    fData.append('gender', rejectedInvDetails?.gender);
    fData.append('phone', rejectedInvDetails?.phone);
    fData.append('registered_address', rejectedInvDetails?.registered_address);
    fData.append('nationality', rejectedInvDetails?.nationality);
    fData.append('country', rejectedInvDetails?.country);
    fData.append('home_country_contact', rejectedInvDetails?.home_country_contact);
    if(rejectedInvDetails?.date_of_birth){
    fData.append('date_of_birth', new Date(rejectedInvDetails?.date_of_birth).getTime());} 
    fData.append('country_of_birth', rejectedInvDetails?.country_of_birth);
    fData.append('passport_number',  rejectedInvDetails?.passport_number);
    if(rejectedInvDetails?.passport_expiry_date){
      fData.append('passport_expiry_date', new Date(rejectedInvDetails?.passport_expiry_date).getTime());}
    fData.append('description_of_income', rejectedInvDetails?.description_of_income);
    fData.append('sourse_of_fund', rejectedInvDetails?.sourse_of_fund);
    fData.append('nominee_details', rejectedInvDetails?.nominee_details);
    fData.append('name_of_employer', rejectedInvDetails?.name_of_employer);
    fData.append('country_of_employer', rejectedInvDetails?.country_of_employer);
    fData.append('national_id', rejectedInvDetails?.national_id);
    fData.append('other_passport_details', rejectedInvDetails?.other_passport_details);
    fData.append('committed_principal', rejectedInvDetails?.committed_principal);
    fData.append('is_pep', rejectedInvDetails?.is_pep);
    fData.append('status',statusFlag)
    fData.append('save_as_draft','0');
    fData.append("deleted_doc",deletedDoc);
   
   
    }else{
      for (let i = 0; i < rejectedCustomers.length; i++) {
        if(rejectedCustomers!==undefined){fData.append('top_5_customers', rejectedCustomers[i])};
      }
      for (let i = 0; i < rejectedSuppliers.length; i++) {
        if(rejectedSuppliers[i]!==undefined){fData.append('top_5_suppliers', rejectedSuppliers[i])};
      }
      // for (let i = 0; i < rejectedBanks.length; i++) {
      //   if(rejectedBanks[i]!==undefined){fData.append('banks_list', rejectedBanks[i])}
      // }
  
      fData.append('investor_id', rejectedInvDetails?.investor_id);
      fData.append('investor_kyc_id', rejectedInvDetails?.investor_kyc_id);
      fData.append('user_id', rejectedInvDetails?.user_id);
      fData.append('investor_company_type', rejectedInvDetails?.investor_company_type);
      fData.append('phone', rejectedInvDetails?.phone);
      fData.append('country', rejectedInvDetails?.country);
      fData.append('sector', rejectedInvDetails?.sector);
      fData.append('registered_address', rejectedInvDetails?.registered_address);
      fData.append('place_of_incorporation', rejectedInvDetails?.place_of_incorporation);
      if(rejectedInvDetails?.date_of_incorporation){
      fData.append('date_of_incorporation', new Date(rejectedInvDetails?.date_of_incorporation).getTime());} 
      fData.append('trade_license_no', rejectedInvDetails?.trade_license_no);
      if(rejectedInvDetails?.trade_license_expiry_date!==''){
      fData.append('trade_license_expiry_date',  new Date(rejectedInvDetails?.trade_license_expiry_date).getTime());}
      fData.append('description_of_business', rejectedInvDetails?.description_of_business);
      fData.append('beneficial_owner_with_percentage_holding', rejectedInvDetails?.beneficial_owner_with_percentage_holding);
      fData.append('shareholders', JSON.stringify(rejectedShareHolderData));
      fData.append('products_by_the_company', rejectedInvDetails?.products_by_the_company);
      fData.append('origin_of_products', rejectedInvDetails?.origin_of_products);
      fData.append('import_countries_with_percentage', rejectedInvDetails?.import_countries_with_percentage);
      fData.append('export_countries_with_percentage', rejectedInvDetails?.export_countries_with_percentage);
      fData.append('re_export_countries_with_percentage', rejectedInvDetails?.re_export_countries_with_percentage);
      if(rejectedInvDetails?.no_of_full_time_employees){fData.append('no_of_full_time_employees', rejectedInvDetails?.no_of_full_time_employees)};
      fData.append('committed_principal', rejectedInvDetails?.committed_principal);
      fData.append('is_pep', rejectedInvDetails?.is_pep);
      fData.append("deleted_doc",deletedDoc);
      fData.append('save_as_draft','0');
    }
    documents_lst.forEach(elem => {
      if (elem.document_url) {
        const fileName = elem.document_url.name;
        const lastDotIndex = fileName.lastIndexOf('.');
        const fileExtension = fileName.substring(lastDotIndex + 1);
        fData.append('file', elem.document_url, elem.document_type + "." + fileExtension);
        if (elem.document_type === "Others") {
          fData.append('file_name', fileName);
        }
      }
    })
    if ((Cookies.get("investor_type")===INVESTOR_TYPE_COMPANY)&&
      (rejectedInvDetails?.sector==''||
       rejectedInvDetails?.country==''||
      rejectedInvDetails?.registered_address==''||
      rejectedInvDetails?.investor_company_type==''||
      rejectedInvDetails?.phone==''||
      rejectedInvDetails?.committed_principal==''||
      rejectedInvDetails?.place_of_incorporation==''||
      rejectedInvDetails?.description_of_business==''||
      rejectedInvDetails?.beneficial_owner_with_percentage_holding==''||
      rejectedInvDetails?.date_of_incorporation==''||
      rejectedInvDetails?.trade_license_expiry_date==''||
      rejectedInvDetails?.products_by_the_company==''||
      rejectedInvDetails?.origin_of_products==''||
      rejectedInvDetails?.import_countries_with_percentage==''||
      rejectedInvDetails?.export_countries_with_percentage==''||
      rejectedInvDetails?.re_export_countries_with_percentage==''||
      rejectedInvDetails?.no_of_full_time_employees==''||
      rejectedInvDetails?.is_pep==''
    )
      
    ) {
      toast.error("Please fill out mandatory fields", {
        toastId: 38,
      });
      setSaveKYCBtn(false)
    }
    // else if(!mandatoryDocuments){
    //   toast.error("Please upload mandatory documents", {
    //     toastId: 380,
    //   });
    // }
    else if((Cookies.get("investor_type")===INVESTOR_TYPE_INDIVIDUAL) && 
      (
        // !rejectedInvDetails.gender||
      //  !indivInvFormData.country||
      // !rejectedInvDetails?.registered_address||
      // !rejectedInvDetails?.committed_principal||
      // !rejectedInvDetails?.phone||
      // !rejectedInvDetails?.investor_company_type ||
      // !rejectedInvDetails?.date_of_birth ||
      // !rejectedInvDetails?.country_of_birth ||
      // !rejectedInvDetails?.country 




      !rejectedInvDetails?.committed_principal||
      !rejectedInvDetails?.country||
      !rejectedInvDetails?.country_of_birth||
      !rejectedInvDetails?.country_of_employer||
      !rejectedInvDetails?.date_of_birth||
      !rejectedInvDetails?.description_of_income||
      !rejectedInvDetails?.nationality||
       !rejectedInvDetails.gender||
       !rejectedInvDetails?.is_pep||
       !rejectedInvDetails?.name_of_employer||
       !rejectedInvDetails?.national_id||
       !rejectedInvDetails?.nominee_details||
       !rejectedInvDetails?.passport_expiry_date||
       !rejectedInvDetails?.passport_number||
       !rejectedInvDetails?.registered_address||
       !rejectedInvDetails?.sourse_of_fund||
      !rejectedInvDetails?.phone

    
    )){
        
          toast.error("Please fill out mandatory fields", {
            toastId: 98,
          });
          setSaveKYCBtn(false)
        }
    else {
      const response = await axios.post(base_url + "investor-master/update_investor_kyc", fData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    
if(response.data.message ==='Updated Investor KYC'){
  toast.success("Submitted Successfully", {
    toastId: 42,
  });
  setTimeout(() => {
    window.location.reload();
  }, 800);}
  
else{
  
  setSaveKYCBtn(false)
  alert("Something went wrong")

}
    }
  // ======end======
  }
  useEffect(() => {
    setIndivInvFormData(masterInvestorData);
  }, [masterInvestorData])
  useEffect(()=>{
    setCompanyFormData(masterInvestorData);
  },[masterInvestorData])
  return (
    <div style={{ display: 'flex', }}>
    <InvestorSideNavBar kycstatus={investorDatauser}/>
    <main style={{ width: "100%" }}>
      <InvestorNavBarMain />

      <div className="pt-3 pb-0 p-4 pagestyle">
        <div className=" d-flex  align-items-center ">
          <h1 className="mb-0">KYC FORM</h1>
        </div>

        <div className="settingsmaindiv">
          <div className="">
            <ul className="nav nav-tabs d-flex" id="myTab" role="tablist">
              <li className="nav-item-indiv-busns" role="presentation">
                <button
                  className="nav-link-inv active p-1"
                  id="BasicDetails-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#BasicDetails-tab-pane"
                  type="button"
                  role="tab"
                  aria-controls="BasicDetails-tab-pane"
                  aria-selected="true"
                >
                  <h3>Form Details</h3>
                </button>
                {investorDatauser?.kyc?.length=== 0  && <span className="text-danger fs-6">Status: Please fill the KYC Form </span>}
                {investorDatauser?.kyc?.length>0 && investorDatauser?.kyc[0]?.status === COMPLIANCE_PENDING && <span className="text-danger fs-6">Status: Under Review</span>}
                {investorDatauser?.kyc?.length>0 && investorDatauser?.kyc[0]?.status=== COMPLIANCE_REJECTED && <span className="text-danger fs-6">Status: Rejected</span>}
                {investorDatauser?.kyc?.length>0 && investorDatauser?.kyc[0]?.status=== COMPLIANCE_APPROVED && <span className="text-danger fs-6">{investorDatauser?.kyc[0]?.kyc_expiry_date < new Date().getTime() ? "KYC expired on": "KYC Approved- Expiry Date"} : {moment(investorDatauser?.kyc[0]?.kyc_expiry_date).format("DD-MMM-YYYY")}{(investorDatauser?.kyc[0]?.kyc_expiry_date) < (new Date().getTime()) ? ". Please fill the KYC form":""}</span>}
              </li>
            </ul>
          </div>
          <div className="tab-content " id="myTabContent">
            <div
              className="tab-pane fade show active "
              id="BasicDetails-tab-pane"
              role="tabpanel"
              aria-labelledby="BasicDetails-tab"
              tabIndex="0"
            >
              {Cookies.get("investor_type")===INVESTOR_TYPE_COMPANY ? 
                <BusinessSettings
                others={others} 
                rejectedShareHolderData={rejectedShareHolderData}
               handleAddRow={handleAddRow}
               plusDisabled={plusDisabled}
               shareHolderData={shareHolderData}
               masterData={masterInvestorData}
               dataUser={investorDatauser}
               defaultvalue={defaultvalue}
               handleRemoveRow={handleRemoveRow}
               statusFlag={statusFlag}
               handleFieldChange={handleFieldChange}
               rejectedDetails={rejectedInvDetails}
               formData={companyFormData}
               rejectedFlag={rejectedFlag}
               rejectedCustomers={rejectedCustomers}
               getDocuments={getDocuments}
               handleCustomerChange={handleCustomerChange}
               updatedCustomers={updatedCustomers}
               rejectedSuppliers={rejectedSuppliers}
               handleSupplierChange={handleSupplierChange}
               updatedSuppliers={updatedSuppliers}
               handleInputChange={handleInputChange}
               download={download}
               handleChange={handleChange}
               handleChangeDownload={handleChangeDownload}
               saveKYCBtn={saveKYCBtn}
               handleSubmit={handleSubmit}
               handleSavechanges={handleSavechanges}
               handleUpdateKyc={handleUpdateKyc}
               handleDeleteClick={handleDeleteClick}
               handleSaveDraftCompany={handleSaveDraftCompany}
               mergedDownloads={mergedDownloads}
               handleIsDataNull={isDataNull}
               handleDeleteClickOthers={handleDeleteClickOthers}
               handleChangeDownloadForOthers={handleChangeDownloadForOthers}
               handleBankChange={handleBankChange}
               />
              :
              <InvestorSettingsIndividual 
              handleUpdateKyc={handleUpdateKyc}
              saveKYCBtn={saveKYCBtn}
              getDocuments={getDocuments}
              masterInvestorData={masterInvestorData}
              statusFlag={statusFlag}
              rejectedInvDetails={rejectedInvDetails}
              indivInvFormData={indivInvFormData}
              investorDatauser={investorDatauser}
              download={download}
              handleChange={handleChange}
              handleChangeDownload={handleChangeDownload}
              handleSubmit={handleSubmit}
              handleSavechanges={handleSavechanges}
              handleFieldChange={handleFieldChange}
              defaultvalue={defaultvalue}
              handleDeleteClick={handleDeleteClick}
              mergedDownloads={mergedDownloads}
             handleSaveDraft={handleSaveDraft}
             handleIsDataNull={isDataNull}
             others={others}
             handleChangeDownloadForOthers={handleChangeDownloadForOthers}
             handleDeleteClickOthers={handleDeleteClickOthers}/>}
            </div>
          </div>
        </div>
      </div>

    </main>
  </div>
  );
};

export default InvestorSettings;